import React from 'react';

// import style from './index.module.scss';

function RelatedTopics() {
  return (
    <div>
      Related Topics
    </div>
  )
}

export default RelatedTopics;
